import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

export const squareIcon = css`
  justify-content: center;
  padding: 1rem;
  background: ${colors.grey.lightFamily.light};
  border-radius: 1rem;
  display: flex;
  color: ${colors.grey.darkFamily.darker};
  margin-top: -1rem;
`;

export const mobileIcon = css`
  color: ${colors.blue.darkFamily.dark};
  width: 10px;
`;

export const title = css``;

export const boxItem = css`
  float: left;
  margin-bottom: 0.25rem;
  width: 100%;
  border-radius: 0.35rem;

  &&&:hover {
    span {
      div {
        background: ${colors.green.base};
        color: ${colors.white};
      }

      color: ${colors.green.base};
    }
  }
`;

export const mobileTitle = css`
  padding-left: 1.5rem;
`;

export const mobileBoxContent = css`
  display: flex;
  justify-content: start;
  padding: 1rem 0 1rem 0;
`;

export const iconBox = css`
  width: 5rem;
  float: left;
  padding: 1rem;
`;

export const descriptionBox = css`
  width: 80%;
  float: left;

  @media only screen and (max-width: ${dimensions.tabletMax}) {
    width: 65%;
  }

  @media (max-width: ${dimensions.phone}) {
    padding-top: 0.25rem;
    width: 60%;
  }
`;

export const description = css`
  margin-top: -0.9rem;
`;
